
import api from './api';

class reviewsIndicators {

	constructor (Api, Session) {
		this.Api = Api;
	}

	summary (query) {
		return this.Api.get({
			url:  'v1.1/m/reviewsIndicators',
			query
		});
	}

}

reviewsIndicators.$inject = ['Api'];

export default angular.module('service.reviewsIndicators', [api])
	.service('reviewsIndicators', reviewsIndicators)
	.name;



// WEBPACK FOOTER //
// ./src/service/reviewsIndicators.js